import { create } from 'zustand';
import {
  getExotelData,
  getExotelStats,
  getMyTeam,
  getExotelStatsForPro,
  getDoctorSlots,
  getAllCommunities,
  getCommunityHistory,
  addCommunity,
  getCategoryData,
  getZeroValueData,
  getCancelledData,
  getRTOData,
  getLostDamagedBy,
  downloadRevenueReport,
  updateCategory,
  createCatSubcat,
  deleteCategory,
  getSearchData,
  getWarehousedata,
  getShippingItemsData,
  postOrderRequest,
  addBulkCommunity,
  taskApi,
  getAllGroups,
  updateMemberActiveStatus,
  deleteMemberFromGroup,
  createTicketngGroup,
  getGroupAssignedToSubcategory,
  assignGropuToSubcateory,
  removeSubcategoryGroup,
  removeTicketGroup,
  getTicketGroupLogs,
  prescribedPatientsCountApi,
  allTaskComponent,
  userSegmentSlug,
  getTicketDashboardData,
  getAuthDashBoardLeadStats,
  getFailedTicket,
  deleteFailtedTicketBackup,
  doctorFollowUp,
  getCommunityEngagements,
  getCommunityEngagementsAssignees,
  updateCommunityEngagementsAssignees,
} from 'pages/api';
import { getSkuReport } from 'modules/warehouse/api';
import { toast } from 'react-toastify';
import _ from 'lodash';

export const useMyTeam = create((set) => ({
  teamData: {},
  isLoading: false,
  isError: false,
  myTeam: async () => {
    set({ isLoading: true });
    try {
      const response = await getMyTeam();
      set({ teamData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useExotelData = create((set) => ({
  exotelData: {},
  isLoading: false,
  isError: false,
  fetchExotelData: async (sd, ed) => {
    set({ isLoading: true });
    try {
      const response = await getExotelData(sd, ed);
      set({ exotelData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useExotelStats = create((set) => ({
  exotelStats: {},
  isLoading: false,
  isError: false,
  fetchExotelStats: async (sd, ed) => {
    set({ isLoading: true });
    try {
      const response = await getExotelStats(sd, ed);
      set({ exotelStats: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useExotelStatsForPro = create((set) => ({
  exotelStatsForPro: {},
  isLoading: false,
  isError: false,
  fetchExotelStatsForPro: async (sd, ed) => {
    set({ isLoading: true });
    try {
      const response = await getExotelStatsForPro(sd, ed);
      set({ exotelStatsForPro: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useDoctorSlots = create((set, get) => ({
  startingDate: '',
  endingDate: '',
  setDates: (sd, ed) => {
    set({ startingDate: sd, endingDate: ed });
  },
  doctorSlotsData: {},
  isLoading: false,
  isError: false,
  fetchDoctorSlots: async (tab, status, users, payment_status) => {
    set({ isLoading: true });
    const { startingDate, endingDate } = get();
    try {
      const response = await getDoctorSlots(
        startingDate,
        endingDate,
        tab,
        status,
        users,
        payment_status
      );
      set({ doctorSlotsData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useAllCommunities = create((set) => ({
  communityData: [],
  communityResponse: '',
  isLoading: false,
  bulkLoading: false,
  responseLoading: false,
  isError: false,
  fetchAllCommunities: async () => {
    set({ isLoading: true });
    try {
      const response = await getAllCommunities();
      set({ communityData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  postAddCommunity: async (payload, setToaster) => {
    set({ responseLoading: true });
    try {
      const response = await addCommunity(payload);
      setToaster('Add Community', 'Added community successfully', 'success');
      set({ communityResponse: response.data, responseLoading: false });
    } catch (error) {
      setToaster(
        'Add Community',
        'Please add Unique Community Name and Slug Name',
        'danger'
      );
      set({ isError: true, responseLoading: false });
    }
  },
  postAddBulkCommunity: async (
    payload,
    setToaster,
    setMessage,
    setModalShow
  ) => {
    set({ bulkLoading: true });
    try {
      const response = await addBulkCommunity(payload);
      setToaster('Community', 'Uploaded successfully', 'success');
      set({ communityResponse: response.data, bulkLoading: false });
      setModalShow(false);
    } catch (error) {
      if (error.response.status === 400) {
        setMessage(`${error.response.data.message}`);
      } else {
        setMessage('Failed to Upload');
      }
      set({ isError: true, bulkLoading: false });
    }
  },
}));

export const useCommunityHistory = create((set) => ({
  communityHistoryData: [],
  historyLoading: false,
  isError: false,
  fetchCommunityHistoryData: async (startDate, endDate) => {
    set({ historyLoading: true });
    try {
      const response = await getCommunityHistory(startDate, endDate);
      set({ communityHistoryData: response.data, historyLoading: false });
    } catch (error) {
      set({ isError: true, historyLoading: false });
    }
  },
}));

export const useCategoryData = create((set, get) => ({
  categorySubcatData: [],
  updatedCategorySubcatData: [],
  createCategorySubcategoryData: [],
  deletedCategory: [],
  isLoading: false,
  isError: false,
  fetchCategoryData: async () => {
    set({ isLoading: true });
    try {
      const response = await getCategoryData();
      set({ categorySubcatData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  editCategoryData: async (payload, setToaster) => {
    const { fetchCategoryData } = get();
    set({ isLoading: true });
    try {
      const response = await updateCategory(payload);
      set({ updatedCategorySubcatData: response.data, isLoading: false });
      setToaster('Category Updation', 'Updated Succesfully', 'success');
    } catch (error) {
      set({ isError: true, isLoading: false });
      setToaster('Category Updation', ' Failed to update', 'danger');
    } finally {
      fetchCategoryData();
    }
  },
  createCategorySubcatgeory: async (payload, setToaster) => {
    const { fetchCategoryData } = get();
    set({ isLoading: true });
    try {
      const response = await createCatSubcat(payload);
      set({ createCategorySubcategoryData: response.data, isLoading: false });
      setToaster(
        'Category Creation',
        'Category created Succesfully',
        'success'
      );
    } catch (error) {
      set({ isError: true, isLoading: false });
      setToaster('Category Creation', ' Failed to create', 'danger');
    } finally {
      fetchCategoryData();
    }
  },
  deleteCategoryData: async (payload, setToaster) => {
    const { fetchCategoryData } = get();
    set({ isLoading: true });
    try {
      const response = await deleteCategory(payload);
      set({ deletedCategory: response.data, isLoading: false });
      setToaster(
        'Category Creation',
        'Category Deleted Succesfully',
        'success'
      );
    } catch (error) {
      set({ isError: true, isLoading: false });
      setToaster('Category Creation', ' Failed to Delete Category', 'danger');
    } finally {
      fetchCategoryData();
    }
  },
}));

export const useSearchData = create((set) => ({
  searchdata: [],
  isLoading: false,
  isError: false,
  fetchSearchData: async (key) => {
    set({ isLoading: true });
    try {
      const response = await getSearchData(key);
      set({ searchdata: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  incrementPrintCount: async (id) => {
    set({ isLoading: true });
    try {
      const response = await printCount(id);
      set({ searchdata: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useWarehouseStore = create((set) => ({
  warehouseData: {},
  isLoading: false,
  isError: false,
  fetchWarehouseData: async () => {
    set({ isLoading: true });
    try {
      const response = await getWarehousedata();
      set({ warehouseData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
}));

export const useShippingItemsData = create((set) => ({
  shippingData: [],
  isLoading: false,
  isError: false,
  fetchShippingData: async (query, pageNumber) => {
    set({ isLoading: true });
    try {
      const response = await getShippingItemsData(query, pageNumber);

      set({ shippingData: response.data, isLoading: false, isError: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
      console.error('Error fetching data:', error);
    }
  },
}));
export const useProcessOrders = create((set) => ({
  orderResponse: '',
  isLoading: false,
  responseLoading: false,
  isError: false,
  postProcessOrder: async (orders, setToaster, type = 'flagged') => {
    set({ responseLoading: true });
    try {
      const response = await postOrderRequest(orders, type);
      setToaster('Prozo allocation', 'Order processed successfully', 'success');
      set({
        orderResponse: response.data,
        responseLoading: false,
        isError: false,
      });
      window.location.reload();
    } catch (err) {
      console.error(err);
      setToaster('Something went wrong, Request failed!', 'danger');
      set({ isError: true, responseLoading: false });
    }
  },
}));
export const useRevenueTracker = create((set) => ({
  _zeroValueData: [],
  _cancelledData: [],
  _rtoData: [],
  lostDamagedByData: [],
  revenueData: [],
  isLoading: false,
  isError: false,
  _fetchZeroValueData: async (pageNo, startDate, endDate, option) => {
    set({ isLoading: true });
    try {
      const response = await getZeroValueData(
        pageNo,
        startDate,
        endDate,
        option
      );
      set({ _zeroValueData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchCancelData: async (pageNo, startDate, endDate) => {
    set({ isLoading: true });
    try {
      const response = await getCancelledData(pageNo, startDate, endDate);
      set({ _cancelledData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  _fetchRTOData: async (pageNo, startDate, endDate) => {
    set({ isLoading: true });
    try {
      const response = await getRTOData(pageNo, startDate, endDate);
      set({ _rtoData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchLostDamagedBy: async (pageNo, startDate, endDate, option) => {
    set({ isLoading: true });
    try {
      const response = await getLostDamagedBy(
        pageNo,
        startDate,
        endDate,
        option
      );
      set({ lostDamagedByData: response.data, isLoading: false });
    } catch (error) {
      set({ isError: true, isLoading: false });
    }
  },
  fetchRevenueReport: async (payload, setToaster) => {
    set({ isLoading: true });
    try {
      const response = await downloadRevenueReport(payload);
      set({ revenueData: response.data, isLoading: false });
      setToaster('Report', `An email has been sent to you.`, 'success');
    } catch (error) {
      setToaster('Report', 'Network response was not ok', 'danger');
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const warehouseReport = create((set) => ({
  isError: false,
  fetchWarehouseReport: async (payload, setToaster) => {
    set({ transitLoading: true });
    try {
      await getSkuReport(payload);
      setToaster(
        'Warehouse report',
        'An email will be sent to you shortly',
        'success'
      );
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const useTaskListData = create((set) => ({
  taskData: [],
  taskLoading: false,
  isError: false,
  fetchTaskListData: async (caseId) => {
    set({ taskLoading: true });
    try {
      const response = await taskApi(caseId);
      set({ taskData: response.data, taskLoading: false, isError: false });
    } catch (error) {
      set({ isError: true, taskLoading: false });
      console.error('Error fetching data:', error);
    }
  },
}));

export const useTicketGroups = create((set, get) => ({
  groups: [],
  groupAssignedToSubcategories: [],
  ticketGroupLogs: [],
  ticketDashboard: [],
  fetchAllGroups: async () => {
    try {
      const response = await getAllGroups();
      set({ groups: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  putMemberActiveStatus: async (payload) => {
    const { fetchAllGroups, fetchTicketGroupLogs } = get();
    try {
      await updateMemberActiveStatus(payload);
      await fetchAllGroups();
      await fetchTicketGroupLogs();
    } catch (error) {
      console.error(error);
      toast.warning(error.response.data.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  },
  removeMemberFromGroup: async (payload) => {
    const { fetchAllGroups, fetchTicketGroupLogs } = get();
    try {
      await deleteMemberFromGroup(payload);
      await fetchAllGroups();
      await fetchTicketGroupLogs();
    } catch (error) {
      toast.warning(error.response.data.message, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  },
  createTicketingGroup: async (payload) => {
    const { fetchAllGroups, fetchTicketGroupLogs } = get();
    try {
      await createTicketngGroup(payload);
      await fetchAllGroups();
      await fetchTicketGroupLogs();
    } catch (error) {
      console.error(error);
    }
  },
  fetchGroupAssignedToSubcategory: async () => {
    try {
      const response = await getGroupAssignedToSubcategory();
      set({ groupAssignedToSubcategories: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  addGroupToSubcategory: async (payload) => {
    const { fetchGroupAssignedToSubcategory, fetchTicketGroupLogs } = get();
    try {
      await assignGropuToSubcateory(payload);
      await fetchGroupAssignedToSubcategory();
      await fetchTicketGroupLogs();
    } catch (error) {
      console.error(error);
    }
  },
  deleteSubcategoryGroup: async (subcatAndGroup) => {
    const { fetchGroupAssignedToSubcategory, fetchTicketGroupLogs } = get();
    try {
      await removeSubcategoryGroup(subcatAndGroup);
      await fetchGroupAssignedToSubcategory();
      await fetchTicketGroupLogs();
    } catch (error) {
      console.error(error);
    }
  },
  deleteTicketGroup: async (payload) => {
    const { fetchAllGroups, fetchTicketGroupLogs } = get();
    try {
      await removeTicketGroup(payload);
      await fetchAllGroups();
      await fetchTicketGroupLogs();
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  },
  fetchTicketGroupLogs: async (pageNumber = 1) => {
    try {
      const response = await getTicketGroupLogs(pageNumber);
      set({ ticketGroupLogs: response.data });
    } catch (error) {
      console.error(error);
    }
  },
  fetchTicketDashboardData: async (payload) => {
    try {
      const response = await getTicketDashboardData(payload);
      set({ ticketDashboard: response.data });
    } catch (error) {
      console.error(error);
    }
  },
}));

export const usePrescribedPatientsCount = create((set) => ({
  count: [],
  taskLoading: false,
  isError: false,
  fetchPrescribedPatientsCount: async (startDate, endDate) => {
    set({ taskLoading: true });
    try {
      const response = await prescribedPatientsCountApi(startDate, endDate);
      set({ count: response.data, taskLoading: false, isError: false });
    } catch (error) {
      set({ isError: true, taskLoading: false });
      console.error('Error fetching data:', error);
    }
  },
}));

export const useMobileHomeTaskList = create((set) => ({
  allComponentData : [],
  componentLoading: false,
  segmentData:[],
  segmentLoading:false,
  isError: false,
  fetchAllComponentData: async () => {
    set({ componentLoading: true });
    try {
      const res= await allTaskComponent();
      set({ componentLoading: false, allComponentData:res.data});
    } catch (error) {
      set({ isError: true, componentLoading:false });
    }
  },
  fetchAllSegmentData: async (caseId) => {
    set({ segmentLoading: true });
    try {
      const res= await userSegmentSlug(caseId);
      set({ segmentLoading: false, segmentData:res.data});
    } catch (error) {
      set({ isError: true, segmentLoading:false });
    }
  },
}));

export const userAllAuthDashBoardLeadStats = create((set) => ({
  allAuthDashBoardLeadStats: [],
  isError: false,
  isLoading: true,
  fetchAllAuthDashBoardLeadStats: async (reportDate) => {
    try {
      const res = await getAuthDashBoardLeadStats(reportDate);
      set({ allAuthDashBoardLeadStats: res.data, isLoading: false });
    } catch (error) {
      set({ isError: true });
    }
  },
}));

export const useDoctorFollowUp = create((set) => ({
  doctorFollowUpSlot: [],
  isError: false,
  isLoading: true,
  handleFollowUpSubmit: async (id,selectedDate ) => {

    try {
      const response = await doctorFollowUp(id, selectedDate);
  
      toast.success('Follow-up created successfully!');
      set({ doctorFollowUpSlot: response.data });
    } catch (error) {
      console.error('Error creating follow-up:', error);
      toast.error('Failed to create follow-up');
    }
  },
}));



export const useFailedTicket = create((set, get) => ({
  failedTicketData: [],
  fetchAllFailed: async (sd, ed, pageNumber, query) => {
    try {
      const response = await getFailedTicket(sd, ed, pageNumber, query);
      set({ failedTicketData: _.get(response, ['data'], []) });
    } catch (error) {
      console.error(error);
    } 
  },
  deleteTicketBackup: async (id) => {
    try {
      const response = await deleteFailtedTicketBackup(id);
      toast.success('Ticket backup deleted successfully.');
    } catch (error) {
      console.error(error);
      toast.error('Failed to deleted Ticket backup.');
    }
  }
}));

export const useCommunityEngagement = create((set) => ({
  communityEngagementsData: [],
  pagination: { page: 1, pageSize: 10, total: 0, totalPages: 1 },
  communityEngagementLoading: false,
  isError: false,
  fetchCommunityEngagementsData: async (params) => {
    set({ communityEngagementLoading: true });
    try {
      console.log(params)
      const response = await getCommunityEngagements(params);
      console.log('response', response.data);


      set({
        communityEngagementsData: response.data.data,
        pagination: response.data.pagination, // Store pagination details
        communityEngagementLoading: false,
      });
    } catch (error) {
      set({ isError: true, communityEngagementLoading: false });
    }
  },
}));

export const useTemporaryEngagementAssignment = create((set) => ({
  communityAssigneeData: [],
  communityAssigneeLoading: false,
  isError: false,
  fetchEngagementsAssigneeData: async () => {
    set({ communityEngagementLoading: true });
    try {
      const response = await getCommunityEngagementsAssignees();
      console.log('response', response.data);


      set({
        communityAssigneeData: response.data,
        communityEngagementLoading: false,
      });
    } catch (error) {
      set({ isError: true, communityEngagementLoading: false });
    }
  },
  updateEngagementsAssigneeData: async (payload) => {
    set({ communityEngagementLoading: true });
    try {
      const response = await updateCommunityEngagementsAssignees(payload);
      console.log('response', response.data);
      toast.success('Temp Assignee updated');
    } catch (error) {
      set({ isError: true, communityEngagementLoading: false });
    }
  },
}));